export default "__VITE_ASSET__BQy$J5UI__"